import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const statusConfig = {
  new: { bg: 'bg-[#E0F2FE]', text: 'text-[#0284C7]', border: 'border-[#BAE6FD]' },
  under_review: { bg: 'bg-[#FEF3C7]', text: 'text-[#D97706]', border: 'border-[#FDE68A]' },
  in_progress: { bg: 'bg-[#F3E8FF]', text: 'text-[#7E22CE]', border: 'border-[#E9D5FF]' },
  pending_documents: { bg: 'bg-[#FEE2E2]', text: 'text-[#DC2626]', border: 'border-[#FECACA]' },
  resolved: { bg: 'bg-[#D1FAE5]', text: 'text-[#059669]', border: 'border-[#A7F3D0]' },
  closed: { bg: 'bg-[#F3F4F6]', text: 'text-[#4B5563]', border: 'border-[#E5E7EB]' },
};

export function CaseStatusBadge({ status }) {
  const { t } = useLanguage();
  const config = statusConfig[status] || statusConfig.new;
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${config.bg} ${config.text} ${config.border}`}
      data-testid="case-status-badge"
    >
      {t(`status_${status}`)}
    </span>
  );
}

export const CASE_STATUSES = ['new', 'under_review', 'in_progress', 'pending_documents', 'resolved', 'closed'];

export function CaseProgressStepper({ currentStatus }) {
  const { t } = useLanguage();
  const currentIndex = CASE_STATUSES.indexOf(currentStatus);

  return (
    <div className="flex items-center gap-1 w-full overflow-x-auto py-2" data-testid="case-progress-stepper">
      {CASE_STATUSES.map((status, idx) => {
        const isCompleted = idx < currentIndex;
        const isCurrent = idx === currentIndex;
        const config = statusConfig[status];
        return (
          <React.Fragment key={status}>
            <div className={`flex flex-col items-center min-w-[80px] ${isCurrent ? 'scale-105' : ''}`}>
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all ${
                  isCompleted ? 'bg-[#0F172A] border-[#0F172A] text-white' :
                  isCurrent ? `${config.bg} ${config.border} ${config.text}` :
                  'bg-slate-100 border-slate-200 text-slate-400'
                }`}
              >
                {isCompleted ? '✓' : idx + 1}
              </div>
              <span className={`text-[10px] mt-1 text-center leading-tight ${isCurrent ? 'font-semibold text-[#0F172A]' : 'text-[#94A3B8]'}`}>
                {t(`status_${status}`)}
              </span>
            </div>
            {idx < CASE_STATUSES.length - 1 && (
              <div className={`flex-1 h-0.5 min-w-[20px] ${idx < currentIndex ? 'bg-[#0F172A]' : 'bg-slate-200'}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
